import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApiProvider } from '@quotech/api';
import { installChunkErrorHandler, installClientErrorReporter } from '@quotech/ui';
import {
  getAuthHeadersForDiagnostics,
  getOrganisationIdForDiagnostics,
} from '@quotech/auth';
import App from './App';
import { setupInventoryApi } from './lib/setupApi';
import './index.css';

// Handle stale chunk 404s after deployment (auto-reload)
installChunkErrorHandler();

// Capture runtime errors + failed fetches to /api/diagnostics/client-error/
// so support agents can root-cause opaque crashes without DevTools.
// See packages/ui/src/diagnostics/clientErrorReporter.ts.
installClientErrorReporter({
  buildSha: import.meta.env.VITE_BUILD_SHA,
  getAuthHeaders: getAuthHeadersForDiagnostics,
  getOrganisationId: getOrganisationIdForDiagnostics,
});

setupInventoryApi();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApiProvider>
      {/* unstable_useTransitions={false} — see apps/newmark/src/main.tsx. (qf!3010, May 2026) */}
      <BrowserRouter unstable_useTransitions={false}>
        <App />
      </BrowserRouter>
    </ApiProvider>
  </React.StrictMode>
);

